module.exports = __webpack_public_path__ + "90897e3b.png";